<script lang="ts" setup>
defineProps<{
  icon: string
  title: string
}>()
</script>

<template>
  <div class="flex min-w-[280px] items-center">
    <SvgIcon class="mr-4 !size-12" :name="icon" />

    <span class="whitespace-normal break-words">
      {{ title }}
    </span>
  </div>
</template>
